// RBAC Permissions - Role-based access control using LoopBack Roles

export const ROLE_SECGROUPS: Record<string, number[]> = {
  'Admin':       [2, 50, 51, 52, 55, 60, 61, 62, 70, 71, 72, 80, 81, 82, 83, 75, 90],
  'Diretoria':   [2, 50, 51, 52, 55, 60, 61, 62, 70, 71, 72, 75, 80, 81, 82, 83],
  'Secretaria':  [2, 50, 51, 52, 55, 60, 61, 62],
  'Coordenacao': [2, 62],
  'Professor':   [2, 62],
  'Financeiro':  [2, 50, 55, 70, 71, 72, 75],
  'Aluno':       [],
  'Conselho':    [],
  'Sem acesso':  [],
};

export function getAllowedSecgroups(role: string | null | undefined): number[] {
  if (!role) return [];
  // Case-insensitive lookup: normalize role to Title Case
  const normalized = role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
  return ROLE_SECGROUPS[normalized] || ROLE_SECGROUPS[role] || [];
}

export function canAccessSecgroup(role: string | null | undefined, secgroup: number): boolean {
  if (secgroup === 2) return true; // secgroup 2 = all authenticated
  return getAllowedSecgroups(role).includes(secgroup);
}

export function hasNoSystemAccess(role: string | null | undefined): boolean {
  if (!role) return true;
  const secgroups = getAllowedSecgroups(role);
  return secgroups.length === 0;
}

export function isProfessorRole(role: string | null | undefined): boolean {
  return role === 'Professor';
}

export function canToggleOkSecretaria(role: string | null | undefined): boolean {
  if (!role) return false;
  const normalized = role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
  return ['Admin', 'Diretoria', 'Secretaria'].includes(normalized);
}
